export const scanOptions = [
  {
    id: "scan",
    product: "scan",
    name: "Security scan",
    amount: 99,
    summary: "The four checks above, with a written report ranked by risk.",
    schemaDescription: "The four checks, with a written report ranked by risk.",
  },
  {
    id: "fix",
    product: "scan_fix",
    name: "Scan plus a fix PR",
    amount: 249,
    summary: "The scan, plus a pull request that fixes the most serious finding.",
    schemaDescription: "The scan, plus a pull request that fixes the most serious finding.",
  },
] as const;

export type ScanOptionId = (typeof scanOptions)[number]["id"];

export const scanServiceDescription =
  "A point-in-time security check for apps built with Lovable, Cursor, Supabase, Neon, or Vercel. It covers leaked keys, open routes, missing row-level security, and unsigned Stripe webhooks, with a written report ranked by risk within 3 business days. From $99. It is not a penetration test.";

export function formatScanPrice(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);
}
